import React, { Component } from "react";
import classnames from "classnames";
import { observable } from "mobx";
import { observer } from "mobx-react";

import { HStack } from "@formant/ui/component/common/HStack";

import { track } from "../../../analytics";
import * as styles from "./index.scss";
import { Page } from "./Page";
import { TabButton } from "./TabButton";

export interface ITabPaginationProps {
    pages: JSX.Element[];
    className?: string;
    position?: "top" | "bottom";
}

@observer
export class TabPagination extends Component<ITabPaginationProps> {
    @observable
    private activeIndex: number = 0;

    public render() {
        const { pages, className, position } = this.props;
        const { activeIndex } = this;

        if (pages.length === 1) {
            return (
                <div
                    className={classnames(styles["tab-pagination"], className)}
                >
                    {pages[0]}
                </div>
            );
        }

        const buttons = (
            <HStack className={styles["tab-buttons"]}>
                {pages.map((_, index) => (
                    <TabButton
                        key={index}
                        index={index}
                        activeIndex={activeIndex}
                        onClicked={this.onClickedTab}
                    />
                ))}
            </HStack>
        );

        return (
            <div
                data-testid="tab-pagination"
                className={classnames(styles["tab-pagination"], className)}
            >
                {position !== "bottom" && buttons}
                {pages.map((_, index) => (
                    <Page key={index} index={index} activeIndex={activeIndex}>
                        {_}
                    </Page>
                ))}
                {position === "bottom" && buttons}
            </div>
        );
    }

    private onClickedTab = (index: number) => {
        track("Teleop tab clicked");
        this.activeIndex = index;
    };
}
